import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!

  return (_openBlock(), _createBlock(_component_ion_toolbar, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_buttons, { slot: "start" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_button, {
            icon: _ctx.arrowBackCircleOutline,
            color: "primary",
            fill: "clear",
            onClick: _ctx.click
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_icon, { icon: _ctx.arrowBackCircleOutline }, null, 8, ["icon"]),
              _createTextVNode(" " + _toDisplayString(_ctx.unSlug(_ctx.backText)), 1)
            ]),
            _: 1
          }, 8, ["icon", "onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}